import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { 
      requiresAuth: false,
      title: 'LifeGuard Yönetim Sistemi - Giriş'
    }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: { 
      requiresAuth: true,
      title: 'LifeGuard Yönetim Sistemi - Kontrol Paneli'
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/Users.vue'),
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true,
      title: 'LifeGuard Yönetim Sistemi - Kullanıcılar'
    }
  },
  {
  path: '/change-password',
  name: 'ChangePassword',
  component: () => import('../views/ChangePassword.vue'),
  meta: { requiresAuth: true }
},
  {
  path: '/ambulans-temizlik',
  name: 'AmbulansTemizlik',
  component: () => import('../views/AmbulansVakaArasiTemizlik.vue'),
  meta: { requiresAuth: true }
},
  {
  path: '/nem',
  name: 'NemKontrol',
  component: () => import('../views/Nem.vue'),
  meta: { requiresAuth: true }
},
  {
  path: '/nobet-km',
  name: 'NobetKm',
  component: () => import('../views/NobetKm.vue'),
  meta: { requiresAuth: true }
},
  {
  path: '/sarj-takip',
  name: 'SarjTakip',
  component: () => import('../views/SarjTakip.vue'),
  meta: { requiresAuth: true }
},
  {
  path: '/gluko-takip',
  name: 'GlukoTakip',
  component: () => import('../views/GlukoTakip.vue'),
  meta: { requiresAuth: true }
},
  {
  path: '/narkotik',
  name: 'Narkotik',
  component: () => import('../views/Narkotik.vue'),
  meta: { requiresAuth: true }
},
  {
  path: '/oksijen',
  name: 'Oksijen',
  component: () => import('../views/Oksijen.vue'),
  meta: { requiresAuth: true }
},
  {
  path: '/temizlik-kontrol',
  name: 'TemizlikKontrol',
  component: () => import('../views/TemizlikKontrol.vue'),
  meta: { requiresAuth: true }
},
  {
    path: '/vehicles',
    name: 'Vehicles',
    component: () => import('../views/Vehicles.vue'),
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true,
      title: 'LifeGuard Yönetim Sistemi - Araçlar'
    }
  },
  {
    path: '/maas',
    name: 'maas',
    component: () => import('../views/Maas.vue'),
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true,
      title: 'LifeGuard Yönetim Sistemi - Maaş & Mesai'
    }
  },
    {
    path: '/organizasyon',
    name: 'organizasyon',
    component: () => import('../views/Organizasyon.vue'),
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true,
      title: 'LifeGuard Yönetim Sistemi - Organizasyon Yönetimi'
    }
  },
  {
    path: '/muhasebe',
    name: 'Muhasebe',
    component: () => import('../views/Muhasebe.vue'),
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true,
      title: 'LifeGuard Yönetim Sistemi - Muhasebe'
    }
  },
  {
    path: '/medical-equipment',
    name: 'MedicalEquipment',
    component: () => import('@/components/Inspections/MedicalEquipment.vue'),
    meta: { 
      requiresAuth: true, 
      roles: ['admin', 'healthworker'],
      title: 'LifeGuard Yönetim Sistemi - Tıbbi Demirbaş'
    }
  },
  {
    path: '/admin-files',
    name: 'AdminFiles',
    component: () => import('../views/AdminFiles.vue'),
    meta: { 
      requiresAuth: true,
      title: 'LifeGuard Yönetim Sistemi - Dosya Yönetimi'
    }
  },
  {
    path: '/stock',
    name: 'Stock',
    component: () => import('../views/Stock.vue'),
    meta: { 
      requiresAuth: true,
      title: 'LifeGuard Yönetim Sistemi - Stok Yönetimi'
    }
  },
  {
    path: '/categories',
    name: 'Categories',
    component: () => import('../views/Categories.vue'),
    meta: { 
      requiresAuth: true,
      title: 'LifeGuard Yönetim Sistemi - Kategoriler'
    }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue'),
    meta: { 
      requiresAuth: true, 
      requiresAdmin: true,
      title: 'LifeGuard Yönetim Sistemi - Ürünler'
    }
  },
  {
    path: '/duties',
    name: 'Duties',
    component: () => import('../views/Duties.vue'),
    meta: { 
      requiresAuth: true,
      title: 'LifeGuard Yönetim Sistemi - Nöbetler'
    }
  },
  {
    path: '/cases',
    name: 'Cases',
    component: () => import('../views/Cases.vue'),
    meta: { 
      requiresAuth: true,
      title: 'LifeGuard Yönetim Sistemi - Vakalar'
    }
  },
    {
    path: '/backup',
    name: 'Backup',
    component: () => import('../views/Backup.vue'),
    meta: { 
      requiresAuth: true,
      title: 'LifeGuard Yönetim Sistemi - Yedekleme'
    }
  },
      {
    path: '/mesaigiris',
    name: 'MesaiGiris',
    component: () => import('../views/MesaiGiris.vue'),
    meta: { 
      requiresAuth: true,
      title: 'LifeGuard Yönetim Sistemi - Mesai Giriş'
    }
  },
  {
    path: '/inspections',
    name: 'Inspections',
    component: () => import('../views/Inspections.vue'),
    meta: { 
      requiresAuth: true,
      title: 'LifeGuard Yönetim Sistemi - Denetimler'
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Title yönetimi için router guard
router.beforeEach((to, from, next) => {
  // Sayfa title'ını ayarla
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'LifeGuard Yönetim Sistemi';
  }

  // Auth kontrolü
  const isAuthenticated = store.getters.isAuthenticated;
  const userRole = store.getters.userRole;

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login');
  } else if (to.meta.requiresAdmin && userRole !== 'admin') {
    next('/');
  } else if (to.meta.roles && !to.meta.roles.includes(userRole)) {
    next('/');
  } else {
    next();
  }
});

export default router;